<template>
  <div class="index-section">
    <Header ref="Headers" />

    <div class="special-column">
      <!-- 加载状态 -->
      <div v-if="loading" class="loading-container">
        <van-loading color="#b8190a" size="24px">加载中...</van-loading>
      </div>
      
      <!-- 空状态 -->
      <div v-else-if="columnList.length === 0" class="empty-container">
        <div class="empty-tip">暂无专题数据</div>
      </div>
      
      <!-- 栏目卡片网格 -->
      <div v-else class="column-grid">
        <div 
          class="column-card" 
          v-for="(item, index) in columnList" 
          :key="index" 
          @click="navigateToList(item.id, item.name)"
        >
          <div class="card-image-container">
            <img
              :src="item.logo"
              :alt="item.name"
              class="card-image"
            >
          </div>
          <div class="card-content">
            <div class="card-title">{{ item.name }}</div>
            <div class="card-time">发布时间：{{ formatDate(item.createTime) }}</div>
          </div>
        </div>
      </div>
    </div>
    
    <Footer />
  </div>
</template>

<script>
import Footer from "@/components/footer.vue";
import Header from "@/components/header.vue";
import { get } from "@/request/http";

// API 路径常量
const API_PATHS = {
  SPECIAL_COLUMN: '/gbs/portal/portal/topic'
};

export default {
  components: {
    Header,
    Footer
  },
  data() {
    return {
      columnList: [],
      loading: false
    };
  },
  activated() {
    this.$refs.Headers.switchTab(7);
    this.loadColumnData();
  },
  methods: {
    /**
     * 格式化日期 YYYYMMDD -> YYYY-MM-DD
     * @param {string} date 格式为 YYYYMMDD 的日期字符串
     * @returns {string} 格式化后的日期字符串
     */
    formatDate(date) {
      if (date && date.length > 8) {
        const year = date.slice(0, 4);
        const month = date.slice(4, 6);
        const day = date.slice(6, 8);
        return `${year}-${month}-${day}`;
      }
      return "";
    },
    
    /**
     * 导航到专栏内容列表页
     * @param {number|string} id 专栏ID
     * @param {string} name 专栏名称
     */
    navigateToList(id, name) {
      this.$router.push({
        path: "/newsList",
        query: {
          categoryId: id,
          title: name
        }
      });
    },
    
    /**
     * 加载专栏数据
     */
    loadColumnData() {
      this.loading = true;
      get(API_PATHS.SPECIAL_COLUMN)
        .then((res) => {
          this.loading = false;
          if (res.code !== 0) {
            this.$Toast && this.$Toast.fail(res.msg);
            return;
          }
          this.columnList = res.data || [];
        })
        .catch((error) => {
          this.loading = false;
          this.$Toast && this.$Toast.fail('加载专栏数据失败');
          console.error('Failed to load column data:', error);
        });
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/assets/style/variable.scss";

.index-section {
  background: $color-bg-page;
  border-radius: 0;
  position: relative;
  min-height: 100vh;
}

.special-column {
  padding: $space-md 15px $space-lg;
}

// 加载状态
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
}

// 空状态
.empty-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
  
  .empty-tip {
    font-size: $font-size-body;
    color: $color-text-sub;
  }
}

// 栏目卡片网格
.column-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: $space-md;
}

// 卡片样式
.column-card {
  background: $color-bg-page;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  cursor: pointer;
  
  &:active {
    transform: scale(0.98);
  }
  
  &:hover {
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
    
    .card-image {
      transform: scale(1.05);
    }
  }
  
  .card-image-container {
    width: 100%;
    height: auto;
    overflow: hidden;
    position: relative;
    
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 30px;
      background: linear-gradient(to top, rgba(0,0,0,0.1), transparent);
      z-index: 1;
    }
  }
  
  .card-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.5s ease;
  }
  
  .card-content {
    padding: $space-sm;
  }
  
  .card-title {
    font-size: $font-size-title-sm;
    font-weight: 600;
    color: $color-text-main;
    line-height: 1.3;
    margin-bottom: 8px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    max-height: 2.6em;
  }
  
  .card-time {
    font-size: $font-size-caption;
    color: $color-text-sub;
    line-height: 1.2;
  }
}

// 响应式布局
@media screen and (min-width: 768px) {
  .column-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media screen and (max-width: 480px) {
  .column-grid {
    grid-template-columns: 1fr;
  }
}
</style>